import "./SOSForSupport.module.css";
import Header from "@/reusable_sections/Header";
import WhyHabeshaPastry from "./sections/WhyHabeshaPastry";
import CommonQuestions from "./sections/CommonQuestions";
import StartYourProject from "./sections/StartYourProject";
import Footer from "@/reusable_sections/Footer";
export default function SOSForSupportPage() {
  return <div>
      <Header />
      <WhyHabeshaPastry />
      <CommonQuestions />
      <StartYourProject />
      <Footer />
    </div>;
}